import { Paths, Views } from './enums';

export const errorRouteNames = <const>[
  Views.PAGE_NOT_FOUND,
  Views.UNAUTHORISED,
  Views.UNHANDLED,
];

const errorRoutes = [{
  path: `/${Paths.UNAUTHORISED}`,
  name: Views.UNAUTHORISED,
  component: (): Promise<typeof import('*.vue')> => import(/* webpackChunkName: "not-authorised-page" */ '@/views/error/PageUnauthorised.vue'),
  meta: {
    title: '401 Unauthorised',
  },
},
{
  path: `/${Paths.UNHANDLED}`,
  name: Views.UNHANDLED,
  component: (): Promise<typeof import('*.vue')> => import(/* webpackChunkName: "unhandled-error-page" */ '@/views/error/PageUnhandledServerError.vue'),
  meta: {
    title: '500 Internal Server Error',
  },
}, {
  path: `/${Paths.PAGE_NOT_FOUND}`,
  name: Views.PAGE_NOT_FOUND,
  component: (): Promise<typeof import('*.vue')> => import(/* webpackChunkName: "not-found-page" */ '@/views/error/PageNotFound.vue'),
  meta: {
    title: '404 Page Not Found',
  },
}];

export default errorRoutes;
